import {$clients} from '@/services/'
const module = {
    namespaced: true,

    state: {
        items: [],
        item: {},
        meta: { pagination: {}}
    },

    getters: {
        items: state => state.items,
        item: state => state.item,
        meta: state => state.meta,
        options: state=>{

            let clients = state.items.map(client=>{
                return {
                    text: `${client.organization}`,
                    value: `${client.id}`
                }
            })

            return [
                {
                    text: "Select Client",
                    value: ''
                },
                ...clients
            ]
        }
    },

    mutations: {
        ITEMS(state, value){
            state.items = value
        },

        ITEM(state,value){
            state.item = value
        },

        ADD_ITEM(state, value){
            state.items.push(value)
        },

        META(state, meta){
            state.meta = meta
        },
    },

    actions: {
        all({commit}, {config}){
            return $clients.all(config).then(function(res){
                let {data, meta} = res.data
                commit('ITEMS', data)
                commit('META', meta)
                return res
            }).catch(function(error){
                this.debug('[client.store/actions/all]::Error', error)
            })
        },
        create({commit}, {payload, config}){
            return $clients.create(payload, config).then(resp => {
                commit('ADD_ITEM', resp.data)
                return resp
            })
        },
        find({ commit }, { id, query }){  
            return $clients.find(id, query)
            .then(resp => {
                commit('ITEM', resp.data)
                return resp
            })
        },
    }
}

export default module
